module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Road-Cone-6e06458d3e6a2302a43b0dfeef39b41f.svg";